
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PhysicianqualificationParameter  extends Parameter {

    searchTerm: number;
    orderBy: string;

}

export interface Physicianqualification {

    id?: number;
    physicianId:any;
    qualificationId:any;
    qualificationNotes:string;  
    institutionId:any;   
    city:string;   
    country:any;
    yearofpassing:string;
     
    tenantId: any;
    branchId: any;
    
    parameters?: PhysicianqualificationParameter[];
    links?: any;

}


export abstract class PhysicianqualificationData { 

    abstract list(url: string): Observable<Physicianqualification[]>;
    abstract create(url: string, data: Physicianqualification): Observable<any>;
    abstract update(url: string, data: Physicianqualification): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}
